function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    /* prettier-ignore */\n    ", "\n    & > * + * {\n      margin-top: ", "px !important;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import Spacing, { BASE_SPACING, BASE_STYLES } from './constants';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withDynamicTag } from '@doordash/utilities'; // This uses a modified "lobotomized owl selector".
// It selects all elements that are immediate children
// of the component `& > …`
// And then uses the universal selector `*` with the
// adjacent sibling selector `+` to select all immediate children
// that are preceded by a sibling.
//
// Resources:
// https://developer.mozilla.org/en-US/docs/Web/CSS/Adjacent_sibling_selectors
// https://alistapart.com/article/axiomatic-css-and-lobotomized-owls

var StackChildren = withDynamicTag(styled.div(_templateObject(), BASE_STYLES, function (props) {
  return props.size;
}));
StackChildren.Sizes = Spacing;
StackChildren.propTypes = {
  size: PropTypes.oneOf(Object.values(StackChildren.Sizes))
};
StackChildren.defaultProps = {
  size: BASE_SPACING
};
export default StackChildren;